import Button from "components/button";
import textServices from "services/text-services";
import ImgAndText from "./components/ImgAndText";
import { ButtonVariant } from "./components/style/button";
import { SubTitleAge, TextTermsAge } from "./components/style/text";

function LegalAge({ setAgeLocal }: { setAgeLocal: (day?: string, month?: string, year?: string) => void }) {

  return (
    <article className="flex-1 flex flex-col items-center justify-center mb-7">
      <ImgAndText />
      <section className="flex flex-col gap-7 px-7 w-full">
        <div className="gap-4 flex flex-col items-center justify-center">
          <SubTitleAge>
            {textServices.findByText('legalage/question', '¿ERES MAYOR DE EDAD?')}
          </SubTitleAge>
          <div className="flex justify-between gap-3 w-5/6">
            <Button className="w-full" onClick={() => {
              gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'AGEGATE - Soy mayor', value: '10' })
              setAgeLocal()
            }}>{textServices.findByText('legalage/button1', 'SI, SOY MAYOR')}</Button>
            <ButtonVariant className="w-full" onClick={() => {
              gtag('event', 'Click', { event_category: GTM_EVENT_CATEGORY, event_label: 'AGEGATE - Soy menor', value: '10' })
              setAgeLocal("21", "6", "22")
            }}>{textServices.findByText('legalage/button2', 'NO, SOY MENOR')}</ButtonVariant>
          </div>
        </div>
        <TextTermsAge className="text-center">{textServices.findByText('legalage/politics', <>AL CONFIRMAR, ACEPTAS LA POLÍTICA DE PRIVACIDAD, TÉRMINOS Y CONDICIONES Y USO DE COOKIES DE ESTE SITIO WEB. ESTE SITIO WEB UTILIZA COOKIES. PARA OBTENER MÁS INFORMACIÓN, <a href={`${process.env.PUBLIC_URL}/terms-and-conditions`} rel="noreferrer" target="_blank" className="underline">LEE NUESTRA POLÍTICA DE PRIVACIDAD Y USO DE COOKIES</a >.</>)}</TextTermsAge>
      </section>
    </article >
  )
}

export default LegalAge;